import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { PlannedPage } from './pages/PlannedPage';
import { plannedPages } from './data/plannedPages';
export function App() {
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3fb14re3nnz9s">
      <BrowserRouter data-id="element-1" data-mp="2rkx5fixi2lol">
        <Routes data-id="element-2" data-mp="2rk44wzp4wsew">
          <Route element={<Layout data-id="element-4" data-mp="2rlf6csv3xo2u" />} data-id="element-3" data-mp="2rlynw8guiagc">
            <Route index element={<Home data-id="element-6" data-mp="2mm2luerpkt3f" />} data-id="element-5" data-mp="2riknv6vnmdc2" />
            {plannedPages.map(page => <Route key={page.slug} path={page.slug} element={<PlannedPage slug={page.slug} data-id="element-8" data-mp="31ayry6a7fw1e" />} data-id="element-7" data-mp="2mjpvbd7vxaer" />)}
            <Route path="*" element={<Home data-id="element-10" data-mp="2wjgqlh49rtfw" />} data-id="element-9" data-mp="31cjou2jzrr2f" />
          </Route>
        </Routes>
      </BrowserRouter>
    </MotionConfig>;
}